const ClientSummary = require('./index.jsx').default;

module.exports = angular
  .module('bench.app.mainapp.details.clientSummary', [])
  .directive('clientSummary', ['reactDirective', reactDirective => reactDirective(ClientSummary)]);
